import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import MainPage from '@/views/Guanwang/MainPage'
import ProductInfo from '@/views/Guanwang/ProductInfo'
import Contact from '@/views/Guanwang/Contact'
import newDy from '@/views/Guanwang/newDy'
import newdetial1 from '@/views/Guanwang/newdetial1'
import newdetial2 from '@/views/Guanwang/newdetial2'
import newdetail3 from '@/views/Guanwang/newdetail3'
import newdetail4 from '@/views/Guanwang/newdetail4'
export default new Router({
  routes: [
    {
      path: '/',
      name: 'mainpage',
      component: MainPage
    },
    {
      path: '/productinfo',
      name: 'productinfo',
      component: ProductInfo
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/newDy',
      name: 'newDy',
      component: newDy
    },
    {
      path: '/newdetial1',
      name: 'newdetial1',
      component: newdetial1
    },
    {
      path: '/newdetial2',
      name: 'newdetial2',
      component: newdetial2
    },
    {
      path: '/newdetail3',
      name: 'newdetail3',
      component: newdetail3
    },
    {
      path: '/newdetail4',
      name: 'newdetail4',
      component: newdetail4
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/indexgw.js